<template>
  <LoadingItem v-if="loading" />
  <div class="login-box" style="background-image: url('/images/login_bg.png')">
    <div class="capcha-box">
      <VueClientRecaptcha @getCode="getCaptchaCode" />
      <div class="capcha-input-box">
        보안코드 : <input v-model="capchaValue" ref="capchaValue" />
      </div>
    </div>
    <div class="input-box input-box1">
      <input
        placeholder="ID"
        v-model="username"
        @keyup.enter="login"
        ref="username"
      />
    </div>
    <div class="input-box input-box2">
      <input
        placeholder="PASSWORD"
        type="password"
        v-model="password"
        @keyup.enter="login"
        ref="password"
      />
    </div>
    <div>
      <button class="login-btn" @click="login"></button>
    </div>
  </div>
</template>

<script>
import VueClientRecaptcha from "vue-client-recaptcha";
import "/public/capcha.css";

export default {
  components: { VueClientRecaptcha },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      capchaCode: "",
      capchaValue: "",
    };
  },
  methods: {
    getCaptchaCode(value) {
      this.capchaCode = value;
    },
    login() {
      const { username, password } = this;

      if (
        this.capchaCode.toLowerCase() !== this.capchaValue.toLowerCase() ||
        this.capchaValue === ""
      ) {
        this.$refs.capchaValue.focus();
        return this.$notify({
          type: "warning",
          text: "보안코드를 확인해주세요.",
        });
      }

      if (username.length === 0) {
        this.$refs.username.focus();
        return this.$notify({
          type: "warning",
          text: "아이디를 입력해주세요.",
        });
      }

      if (password.length === 0) {
        this.$refs.password.focus();
        return this.$notify({
          type: "warning",
          text: "비밀번호를 입력해주세요.",
        });
      }

      this.loading = true;

      this.$store
        .dispatch("login", { username, password })
        .then((response) => {
          if (response.status === 200) {
            this.$router.push("/Member/List");
          }
        })
        .catch(() => {
          this.$refs.username.focus();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
